export default function AdminBehaviorEditExercises() {
  return <div className="">general</div>;
}
